import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const stats = [
  { value: '300+', label: '收录漫画' },
  { value: '24h', label: '持续更新' },
  { value: '58万', label: '日活读者' },
];

export default function Hero() {
  const [query, setQuery] = useState('');
  const [focus, setFocus] = useState(false);

  const results = query.trim()
    ? comics.filter((c) => c.title.includes(query.trim()) || c.tags.some((t) => t.includes(query.trim()))).slice(0, 4)
    : [];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20suspenseful%20comic%20portal%20hero%20artwork%20of%20a%20foggy%20noir%20cityscape%20at%20midnight%20with%20towering%20silhouetted%20buildings%20and%20crimson%20red%20neon%20glow%20bleeding%20through%20the%20mist%2C%20gritty%20manga%20ink%20texture%2C%20moody%20dramatic%20cinematic%20lighting%2C%20ominous%20deep%20shadows%20and%20amber%20highlights&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
          alt="嘿嘿漫画网深夜档暗黑向漫画首屏背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 py-24 text-center md:py-32">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-4 py-1.5 text-xs text-primary-300 backdrop-blur-sm">
          <i className="ri-flashlight-line" aria-hidden="true"></i>
          深夜档 · 重口味 · 暗黑向 精选专区
        </span>

        <h1 className="max-w-3xl font-heading text-3xl leading-tight text-foreground-950 text-shadow-dark md:text-5xl">
          深夜档重口味剧情漫画，<br className="hidden md:block" />
          <span className="text-primary-400">在线看</span>最带感的暗黑故事
        </h1>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
          嘿嘿漫画网汇聚都市诡异、悬疑烧脑、血浆恐怖与暗黑人性等题材。剧情带感、画风大胆、更新飞快，收藏本站，第一时间追更最新深夜档。
        </p>

        <div className="relative mt-8 w-full max-w-xl">
          <div className="flex items-center rounded-full border border-background-200/60 bg-black/50 p-1.5 backdrop-blur-md">
            <i className="ri-search-line pl-3 text-base text-foreground-500" aria-hidden="true"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onFocus={() => setFocus(true)}
              onBlur={() => setTimeout(() => setFocus(false), 150)}
              placeholder="搜索你想追的漫画或题材"
              className="w-full bg-transparent px-3 text-sm text-foreground-950 outline-none placeholder:text-foreground-500"
            />
            <Link
              to="/category/shenye"
              className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              开始追更
            </Link>
          </div>
          {focus && results.length > 0 && (
            <div className="absolute top-full left-0 right-0 z-20 mt-2 overflow-hidden rounded-2xl border border-background-200 bg-background-100 shadow-2xl">
              {results.map((c) => (
                <Link
                  key={c.id}
                  to={`/comic/${c.id}`}
                  className="flex items-center gap-3 border-b border-background-200/60 px-4 py-2.5 transition-colors last:border-0 hover:bg-secondary-100"
                >
                  <span className="h-12 w-9 shrink-0 overflow-hidden rounded bg-background-300">
                    <img src={c.cover} alt={c.title} className="h-full w-full object-cover object-top" />
                  </span>
                  <span className="text-left">
                    <span className="block text-sm text-foreground-950">{c.title}</span>
                    <span className="block text-xs text-foreground-500">{c.tags.join(' · ')}</span>
                  </span>
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className="mt-10 flex items-center gap-8 md:gap-12">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-2xl text-accent-400 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-foreground-400">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}